module.exports = __webpack_public_path__ + "img/bank-001-korea.5021cd01.svg";